import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Sparkles } from 'lucide-react';

/**
 * Overlay em tela cheia enquanto a análise IA está em curso.
 * Animação em CSS (sem Lottie) para não aumentar o bundle; pode trocar por lottie-react + JSON se quiser.
 */
export default function AiGeneratingOverlay({
  open,
  title = 'Gerando sugestões com IA',
  subtitle = 'Consultando a legislação e preparando as sugestões. Pode levar de alguns segundos a alguns minutos.',
}) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open || typeof document === 'undefined') return null;

  const node = (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-slate-900/60 backdrop-blur-md px-4"
      role="alertdialog"
      aria-modal="true"
      aria-busy="true"
      aria-labelledby="ai-gen-overlay-title"
      aria-describedby="ai-gen-overlay-desc"
    >
      <div className="relative w-full max-w-md rounded-2xl bg-white shadow-2xl border border-gray-100 px-8 py-10 text-center">
        <div className="ai-gen-glow pointer-events-none absolute -inset-px rounded-2xl opacity-60" aria-hidden />

        <div className="relative mx-auto mb-8 flex h-32 w-32 items-center justify-center">
          <span className="ai-gen-ring-pulse absolute inset-0 rounded-full border-2 border-primary-500/35" aria-hidden />
          <span className="ai-gen-ring-pulse ai-gen-ring-delay absolute inset-3 rounded-full border border-primary-400/25" aria-hidden />
          <span
            className="absolute inset-5 rounded-full border-2 border-transparent border-t-primary-700 border-r-primary-500/40 animate-spin"
            style={{ animationDuration: '1.15s' }}
            aria-hidden
          />
          <Sparkles
            className="relative z-10 h-12 w-12 text-primary-800 ai-gen-sparkle"
            strokeWidth={1.75}
            aria-hidden
          />
        </div>

        <h2 id="ai-gen-overlay-title" className="text-lg font-semibold text-gray-900">
          {title}
        </h2>
        <p id="ai-gen-overlay-desc" className="mt-3 text-sm leading-relaxed text-gray-600">
          {subtitle}
        </p>
        <div className="mt-8 flex justify-center gap-1.5" aria-hidden>
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="h-2 w-2 rounded-full bg-primary-600 ai-gen-dot"
              style={{ animationDelay: `${i * 0.2}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  );

  return createPortal(node, document.body);
}
